import React from 'react';
import { SquareSvgProps } from '@icons/icon.types';
import { PlcColor } from '@styles/colors';

function CalendarIcon({ title, size = 24, fillColor = PlcColor.BLUE_LAND, ...props }: SquareSvgProps) {
  return (
    <svg height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
      {title && <title>{title}</title>}
      <g fill={fillColor} fillRule="evenodd">
        <path d="M22 4v18H2V4h20zm-2 2H4v14h16V6z" />
        <path d="M8 2v6H6V2zM8 11v2H6v-2zM13 11v2h-2v-2zM18 11v2h-2v-2zM8 16v2H6v-2zM13 16v2h-2v-2zM18 16v2h-2v-2zM18 2v6h-2V2z" />
      </g>
    </svg>
  );
}

export { CalendarIcon };
